<div fxLayout="column" style="position: relative;">
  <div #enterToEdit [tabindex]="isViewOnly ? -1 : 0" class="enter-to-edit" (keydown)="enterToEditKeydown($event)" role="button">
    Press <kbd>Enter</kbd> to edit
    <forge-focus-indicator></forge-focus-indicator>
  </div>
  <label slot="label" [for]="id" class="forge-typography--label2">{{label}}</label>
  <div fxLayout="column" class="rich-text-container" [id]="id" [ngClass]="{'disabled': isViewOnly}">
    <quill-editor [name]="Name" attr.aria-label="Edit-{{label}}" format="html" sanitize="true"
      [placeholder]="label" [(ngModel)]="valueModel" [required]="isRequired"
      (onEditorCreated)="onQuillEditorCreated($event)" role="textbox">
      <div quill-editor-toolbar class="quill-editor-toolbar" [ngClass]="{'ql-disabled': isViewOnly}">
        <span class="ql-formats">
          <button class="ql-bold" id="{{id}}-bold">
            <forge-tooltip placement="bottom">Bold</forge-tooltip>
          </button>
          <button class="ql-italic" id="{{id}}-italic"></button>
          <button class="ql-underline" id="{{id}}-underline"></button>
          <button class="ql-strike"> </button>
          <button class="ql-script" value="sub"></button>
          <button class="ql-script" value="super"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-align circular"></select>
          <button class="ql-indent" value="-1"></button>
          <button class="ql-indent" value="+1"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-size"></select>
        </span>
        <span class="ql-formats">
          <select class="ql-header">
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
            <option value="6"></option>
          </select>
        </span>
        <span class="ql-formats">
          <select class="ql-color circular"></select>
          <select class="ql-background circular"></select>
        </span>
        <span class="ql-formats">
          <select class="ql-font"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-clean"></button>
          <forge-tooltip placement="bottom">Clear formatting</forge-tooltip>
        </span>
        <span class="ql-formats">
          <button class="ql-link"></button>
          <button class="ql-image"></button>
        </span>
        <span class="ql-formats">
          @if (hasLookup) {
            <forge-select (change)="appendOption($event.detail)" aria-label="select value" dense>
              @for (field of Fields; track field) {
                <forge-option [value]="field">{{field}}</forge-option>
              }
            </forge-select>
          }
        </span>
      </div>
    </quill-editor>
  </div>
</div>
